<template>
  <div class="banner1">
    <div>请上传轮播图，点击添加即可添加图片，推荐尺寸1200*650，可拖动排序</div>
    <draggable
      v-model="currentInfo.wxSchoolPageItemList"
      @update="datadragEndContent"
      :options="{ animation: 500 }"
    >
      <div
        class="mt20 wx-item-style"
        v-for="(item, index) in currentInfo.wxSchoolPageItemList"
        :key="index"
      >
        <el-upload
          :action="fileObj.url"
          :before-upload="beforeUpload"
          :on-success="successListUpdate"
          :headers="reqData"
          :show-file-list="false"
        >
          <img
            class="list-img"
            :src="item.picture"
            @click="updateImg(index)"
            v-if="item.picture"
          />

          <div @click="updateImg(index)" v-else class="addIcon">
            <i class="el-icon-plus" />
          </div>
        </el-upload>
        <div class="flex mt10 jc-center">
          <el-button type="danger" @click="deleteBtn(index)" v-if="item.picture"
            >删除<i class="el-icon-delete"
          /></el-button>
        </div>
      </div>
    </draggable>
  </div>
</template>
<script>
import { codeMixin } from "../../../minix";
export default {
  mixins: [codeMixin],

  methods: {
    deleteBtn(index) {
      this.currentInfo.wxSchoolPageItemList[index].picture = "";
      this.currentInfo.wxSchoolPageItemList[index].isEmpty = 1;
    },
  },
};
</script>
<style lang="less" scoped>
.banner1 {
  /deep/ .el-upload {
    width: 100%;
    .list-img {
      width: 100%;
      object-fit: cover;
      max-height: 100px;
    }
  }
  .el-input {
    width: 250px;
  }
  .el-empty {
    padding: 10px 0;
  }
  .wx-item-style {
    padding: 10px;
    box-sizing: border-box;
  }
  .addIcon {
    padding: 30px;
    box-sizing: border-box;
    border: 1px dashed #fff;
    width: 100%;
    .el-icon-plus {
      font-size: 42px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/banner/banner1/setting.vue